import { twMerge } from "tailwind-merge"

import { FlashKind } from "~/src/hooks/useFlasher"

export type ButtonKind = "primary" | "secondary" | "text" | "ghost"

const BORDERED_BUTTON_KINDS: Array<ButtonKind> = ["primary", "secondary"]

export function buttonClassName(kind: ButtonKind) {
  return twMerge(
    BORDERED_BUTTON_KINDS.includes(kind) && [
      "inline-block cursor-pointer rounded-lg border px-4 text-center font-medium whitespace-nowrap disabled:cursor-not-allowed",
      // Remove border width from padding to get pixel perfect look
      "py-[calc(--spacing(2)-theme(borderWidth.DEFAULT))]",
    ],
    kind === "primary" && [
      "border-navy-800",
      "disabled:border-gray-300",
      "bg-navy-800",
      "disabled:bg-gray-300",
      "text-white",
    ],
    kind === "secondary" && ["border-gray-300", "bg-transparent", "text-gray-900", "disabled:text-gray-300"],
    kind === "text" && ["text-gray-500", "font-normal", "underline", "leading-none"],
    kind === "ghost" && ["bg-transparent", "border-transparent", "text-gray-500"]
  )
}

export function flashClassName(kind: FlashKind = FlashKind.Info, square: boolean = false) {
  return twMerge(
    "flex scroll-m-8 flex-row justify-between p-4 text-sm",
    square ? "rounded-none" : "rounded-lg",
    kind === "info" && "bg-sky-100 text-blue-600",
    kind === "success" && "bg-green-100 text-emerald-700",
    kind === "warning" && "bg-orange-100 text-yellow-800",
    (kind === "error" || kind === "danger") && "bg-rose-100 text-red-600"
  )
}
